import React, { useEffect, useState } from "react";
import {
    Grid,
    Box,
    Typography,
    Button,
    Card,
    CardContent,
} from "@mui/material";
import { axiosInstance } from "../../utils/tokenSetCookie";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

interface PlanType {
    label: string;
    plan_id: string;
    price: string;
    plan_amount?: string;
}

interface PlanSelectorProps {
    selectedPlan: string | null;
    onSelect: (plan: string) => void;
}

const features = [
    "Growing content library",
    "Unlimited access",
    "Easy patient sharing",
    "Enhanced Security",
    "Boost Google Reviews",
];

// Function to calculate discount percentage
const calculateDiscount = (originalPrice: string, price: string) => {
    const original = parseFloat(originalPrice.replace("$", ""));
    const discounted = parseFloat(price.replace("$", ""));
    const discount = ((original - discounted) / original) * 100;
    return Math.round(discount);
};

const PlanDetails: React.FC<PlanSelectorProps> = ({ selectedPlan, onSelect }) => {
    const [plans, setPlans] = useState<PlanType[]>([]);
    const website: string | null = localStorage.getItem("website");

    useEffect(() => {
        const getPayment = async () => {
            try {
                const response = await axiosInstance.get(
                    `${API_BASE_URL}products/list-all-products?websiteId=${encodeURIComponent(
                        website ?? ""
                    )}`
                );

                if (response.status >= 200 && response.status <= 300) {
                    const apiPlans: PlanType[] =
                        response.data?.data.map((item: any) => ({
                            label: item.periodType === "monthly" ? "Monthly" : "Yearly",
                            price: `$${item.amount}`,
                            plan_id: `${item.priceId}`,
                            plan_amount: item.plan_amount ? `$${item.plan_amount}` : undefined,
                        })) || [];

                    setPlans(apiPlans);
                }
            } catch (error) {
                console.error("Error fetching plans:", error);
            }
        };

        if (website) {
            getPayment();
        }
    }, [website]);



    return (
          
<>
            {/* Content */}
                                {plans.map((plan, index) => {
                        const discount = plan.plan_amount
                            ? calculateDiscount(plan.plan_amount, plan.price)
                            : null;

                        const isSelected = selectedPlan === plan.plan_id;

                        return (
                            <Grid item xs={12} sm={12} md={5.5} lg={5.5} key={index} sx={{maxWidth: '100%', padding: '0 !important',}}>
                                <Card
                                    onClick={() => onSelect(plan.plan_id)}
                                    sx={{
                                        height: "100%",
                                        borderRadius: "20px",
                                        transform: isSelected
                                            ? "translateY(-5px)" : "translateY(0px)",
                                        background: isSelected
                                            ? "linear-gradient(135deg, #0033a7, #619fff)"
                                            : "rgba(255, 255, 255, 0.15)",
                                        backdropFilter: "blur(15px)",
                                        border: "1px solid rgba(255, 255, 255, 0.25)",
                                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                        color: "#fff",
                                        maxWidth: '100%',
                                        minHeight: '351px',
                                        cursor: "pointer",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            boxShadow: "0 0 35px rgba(123,97,255,0.6)",
                                            background: "linear-gradient(135deg, #0033a7, #619fff)",
                                        },
                                    }}
                                >
                                    <CardContent sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: "inherit" }}>
                                        <Box>
                                        <Typography
                                            variant="h6"
                                            textAlign="center"
                                            sx={{ mb: 1, fontWeight: 600 }}
                                        >
                                            {plan.label} Plan
                                        </Typography>

                                        {/* Price + Discount */}
                                        <Box textAlign="center" mb={2}>
                                            {plan.plan_amount && (
                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    gap={1}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            textDecoration: "line-through",
                                                            opacity: 0.8,
                                                        }}
                                                    >
                                                        {plan.plan_amount}
                                                    </Typography>
                                                    {discount && (
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: "yellow",
                                                                fontSize: "12px",
                                                            }}
                                                        >
                                                            -{discount}%
                                                        </Typography>
                                                    )}
                                                </Box>
                                            )}
                                            <Typography
                                                variant="h4"
                                                sx={{ fontWeight: 700, color: "#fff" }}
                                            >
                                                {plan.price}
                                                <Typography variant="h6" component="span" sx={{ fontWeight: 400, color: "#fff", fontSize: '0.75rem' }}>
                                                    /{plan.label}
                                                </Typography>
                                            </Typography>
                                        </Box>

                                        {/* Features */}
                                        <Box sx={{ mb: 3 }}>
                                            {features.map((f, i) => (
                                                <Typography
                                                    key={i}
                                                    variant="body2"
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        mb: 1,
                                                        opacity: 0.9,
                                                    }}
                                                >
                                                    ✓&nbsp; {f}
                                                </Typography>
                                            ))}
                                        </Box>
                                        </Box>
                                      <Box>
                                        <Box textAlign="center">
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    background: isSelected ? "#fff"
                                                        : "linear-gradient(135deg, #0033a7, #619fff)", 
                                                    color:  isSelected ? "#0033a7" : "#fff",
                                                    borderRadius: "25px",
                                                    px: 4,
                                                }}
                                            >
                                                {isSelected ? "Selected" : "Select Plan"}
                                            </Button>
                                        </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
            </>
    );
};

export default PlanDetails;
